import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Reveal from "./Reveal";

export default function Testimonials({ t }) {
  const [i, setI] = useState(0);
  const items = t.testi.items;
  const next = () => setI((v) => (v + 1) % items.length);
  const prev = () => setI((v) => (v - 1 + items.length) % items.length);

  return (
    <section className="py-24 md:py-32 border-t border-[var(--border)]">
      <div className="container-x grid grid-cols-12 gap-6 md:gap-12">
        <div className="col-span-12 md:col-span-4">
          <Reveal>
            <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] font-display">
              <span className="w-6 h-[1px] bg-[var(--accent)]" />
              {t.testi.overline}
            </div>
          </Reveal>
          <Reveal delay={0.05} y={30}>
            <h3 className="mt-5 font-display font-black uppercase leading-[0.95] tracking-tighter text-5xl md:text-7xl text-[var(--text)]">
              {t.testi.title}
            </h3>
          </Reveal>
          <div className="mt-10 hidden md:flex items-center gap-3">
            <button
              onClick={prev}
              className="w-12 h-12 rounded-full border border-[var(--border)] flex items-center justify-center text-[var(--text)] hover:border-[var(--accent)] hover:text-[var(--accent)] transition-all"
              data-testid="testi-prev"
              aria-label="Previous"
            >
              ←
            </button>
            <button
              onClick={next}
              className="w-12 h-12 rounded-full border border-[var(--border)] flex items-center justify-center text-[var(--text)] hover:border-[var(--accent)] hover:text-[var(--accent)] transition-all"
              data-testid="testi-next"
              aria-label="Next"
            >
              →
            </button>
            <div className="ml-4 font-display text-xs uppercase tracking-widest text-[var(--text-muted)]">
              0{i + 1} / 0{items.length}
            </div>
          </div>
        </div>

        <div className="col-span-12 md:col-span-8 min-h-[220px]">
          <AnimatePresence mode="wait">
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`testi-card-${i}`}
            >
              <div className="text-[var(--accent)] font-serif-italic text-6xl leading-none">
                &ldquo;
              </div>
              <p className="mt-2 font-serif-italic text-2xl md:text-4xl leading-tight text-[var(--text)] max-w-3xl">
                {items[i].quote}
              </p>
              <div className="mt-10 pt-6 border-t border-[var(--border)] flex items-center justify-between gap-4">
                <div>
                  <div className="font-display font-bold text-lg text-[var(--text)]">
                    {items[i].name}
                  </div>
                  <div className="text-sm text-[var(--text-muted)]">
                    {items[i].role}
                  </div>
                </div>
                <div className="flex md:hidden items-center gap-3">
                  <button
                    onClick={prev}
                    className="w-10 h-10 rounded-full border border-[var(--border)] flex items-center justify-center"
                    aria-label="Previous"
                    data-testid="testi-prev-mobile"
                  >
                    ←
                  </button>
                  <button
                    onClick={next}
                    className="w-10 h-10 rounded-full border border-[var(--border)] flex items-center justify-center"
                    aria-label="Next"
                    data-testid="testi-next-mobile"
                  >
                    →
                  </button>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}
